function createMonogramFaviconDataUri(monogram, bgColor) {
  const safeMonogram = monogram.trim().slice(0, 3).toUpperCase() || "CF";
  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <rect width="64" height="64" rx="12" fill="${bgColor}" />
  <text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-family="Montserrat, sans-serif" font-size="24" font-weight="700" fill="#eafff1">${safeMonogram}</text>
</svg>`.trim();
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
function findOrCreateFaviconElement() {
  const existing = document.querySelector('link[rel="icon"]');
  if (existing) {
    return existing;
  }
  const element = document.createElement("link");
  element.rel = "icon";
  document.head.appendChild(element);
  return element;
}
function toRgbChannels(color) {
  const value = color.trim();
  const shortHex = /^#([0-9a-f]{3})$/i.exec(value);
  if (shortHex) {
    const [r, g, b] = shortHex[1]
      .split("")
      .map((channel) => Number.parseInt(channel + channel, 16));
    return { r, g, b };
  }
  const fullHex = /^#([0-9a-f]{6})$/i.exec(value);
  if (fullHex) {
    const hex = fullHex[1];
    return {
      r: Number.parseInt(hex.slice(0, 2), 16),
      g: Number.parseInt(hex.slice(2, 4), 16),
      b: Number.parseInt(hex.slice(4, 6), 16),
    };
  }
  return null;
}
export const appConfig = {
  projectName: "Fifty Fifty",
  branding: {
    favicon: "/favicon.ico",
  },
  theme: {
    buttonColor: "#FC4420",
    buttonTextColor: "#032211",
    backgroundColor: "#02150f",
  },
};
export function applyAppConfig(config) {
  document.title = config.projectName;
  const faviconElement = findOrCreateFaviconElement();
  faviconElement.href = config.branding.favicon;
  const root = document.documentElement;
  root.style.setProperty("--project-bg-color", config.theme.backgroundColor);
  root.style.setProperty("--project-button-color", config.theme.buttonColor);
  root.style.setProperty(
    "--project-button-text-color",
    config.theme.buttonTextColor,
  );
  root.style.setProperty("--accent", config.theme.buttonColor);
  const accentRgb = toRgbChannels(config.theme.buttonColor);
  if (accentRgb) {
    root.style.setProperty(
      "--accent-soft",
      `rgba(${accentRgb.r}, ${accentRgb.g}, ${accentRgb.b}, 0.16)`,
    );
  }
}
